export type SignatureState = {
  show: boolean;
  onSuccess?: () => void;
};

export const emptySignatureState: SignatureState = {
  show: false,
};
